'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useCallback, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Front';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import RegistrationForm from 'Components/Forms/Models/User/RegistrationForm';
import LoginForm from 'Components/Forms/LoginForm';
import Breadcrumb from 'Components/Front/Breadcrumb';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import Link from 'Pure/Link';
import removeGetParameter from 'Functions/removeGetParameter';
import bemit from 'Functions/bemit';
import { getUrlParameter } from 'Shared/utilities';
import { URL } from 'Shared/Routes';
const {
  app
} = window;
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Connexion myWO',
  url: URL('CustomerLogin')
}];
export default function CustomerLoginPage(props) {
  const [registered, setRegistered] = useState(getUrlParameter('register') === 'true');
  const [registered_email, setRegisteredEmail] = useState(getUrlParameter('emailed') === 'true');
  const [form, setForm] = useState('login');
  const [message, setMessage] = useState();
  useEffect(() => {
    removeGetParameter('register');
    removeGetParameter('emailed');
  }, []);
  const handle3rdPartyLoginNotFound = useCallback(function () {
    setMessage({
      warning: 'Vous n\'avez pas encore de compte myWo, inscrivez-vous via la méthode de votre choix ci-dessous.'
    });
    setForm('registration');
  }, []);
  const handleRequestLoginForm = useCallback(function () {
    setMessage({
      info: 'Votre compte a été créé avec succès, vous pouvez maintenant vous y connecter.'
    });
    setForm('login');
  }, []);
  const handleRegistration = useCallback(function (response) {
    const {
      info,
      ...session
    } = response;
    app.state.session = session;
    app.state.session.fetched = true;
    setMessage(undefined);
    setRegistered(true);
    setRegisteredEmail(true);
  }, []);
  const handleRegisterClick = useCallback(function (e) {
    setForm('registration');
  }, []);
  const displayed_form = registered ? /*#__PURE__*/React.createElement(React.Fragment, null, getFormStatus({
    info: 'Inscription réussie, bienvenue sur myWO !' + (registered_email ? ' Nous vous avons envoyé un email de confirmation.' : '')
  }, ['v2']), /*#__PURE__*/React.createElement(Link, {
    href: "/",
    className: "home-link"
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "u-margin-right-10"
  }), " Retour au site myWO")) : form === 'login' ? /*#__PURE__*/React.createElement(LoginForm, {
    "with-google": true,
    "with-linkedin": true,
    source: "CustomerLoginPage",
    "allow-registration": true,
    on3rdPartyLoginNotFound: handle3rdPartyLoginNotFound
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-separator c-separator--light\r u-margin-top-30 u-margin-bottom-30"
  }, "Pas encore de compte\xA0?"), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-margin-top-25 u-text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: handleRegisterClick,
    className: bemit('c-flat-btn', ['front', 'blue', 'front-search', 'full-width'])
  }, "Je m'inscris"))) : /*#__PURE__*/React.createElement(RegistrationForm, {
    onRegistration: handleRegistration,
    source: "CustomerLoginPage",
    "with-google": true,
    "with-linkedin": true,
    requestLoginForm: handleRequestLoginForm
  });
  return /*#__PURE__*/React.createElement(Layout, _extends({
    page_title: "Connexion myWO"
  }, props), /*#__PURE__*/React.createElement("div", {
    className: bemit('c-front-page-intro', ['static-page'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__bg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__left"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "c-front-page-intro__title"
  }, form === 'login' ? 'Connexion myWO' : 'Inscription myWO')))), /*#__PURE__*/React.createElement("div", {
    className: "front-internal-page"
  }, /*#__PURE__*/React.createElement(Breadcrumb, {
    links: breadcrumb,
    bemit: ['no-padding'],
    className: "u-margin-bottom-10"
  }), /*#__PURE__*/React.createElement("h2", {
    className: 'c-title c-title--sub' + (registered || form !== 'login' ? ' u-margin-bottom-30' : '')
  }, "Bienvenue"), message ? getFormStatus(message, ['v2']) : undefined, displayed_form));
}
